import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'
import { FaUserEdit, FaUserTimes } from 'react-icons/fa';

const UsersTable = ({
    users, 
    onDelete, 
    onEdit}) => {

    const columns = React.useMemo(
        () => [
            {
                header: 'Name',
                accessorKey: 'name',
            },
            {
                header: 'Email Address',
                accessorKey: 'email',
            },
            {
                header: 'Username',
                accessorKey: 'username',
            },
            {
                header: 'Role',
                accessorKey: 'role',
            },
            {
                header: 'Phone Number',
                accessorKey: 'phone'
            },
            {
                header: 'Date Created',
                accessorKey: 'created_at',
            },
            {
                header: 'Date Updated',
                accessorKey: 'updated_at',
            },
            {
                header: 'Actions',
                id: 'actions',
                cell: ({row}) => (
                    <>
                        <FaUserTimes 
                            className='fa-times'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onDelete(row.original.id)}
                            title='Delete'
                        />
                        <FaUserEdit
                            className='fa-edit'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={() => onEdit(row.original.id)}
                            title='Edit'
                        />
                    </>
                )
            }
        ],
        [onDelete, onEdit]
    );

    const table = useReactTable({
        data: users,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    if (users.length === 0){
        return <div className="text-center">No users found</div>;
    }
  return (
    <table className='table table-striped'>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default UsersTable